import React from "react";
import attendanceCalendar from "assets/images/icons/attendanceCalendar.svg";
import moment from "moment";

export const AttendanceMarkingModalBody = ({ serverTime = "" }) => {
  return (
    <div>
      <p className="attendance-heading">Today’s Attendance Required  </p>
      <div className="d-flex justify-content-center gap-2 mt-2 mb-3">
        <img src={attendanceCalendar} alt="Attendance-Calendar" />
        <span>{serverTime && moment(serverTime)?.format("DD MMMM YYYY")}</span>
      </div>
      <h3 className="attendance-check">
        You’ll need to check in before starting your learning or taking any
        exams.
      </h3>
    </div>
  );
};
